interface Data {
    companyRemaining: number;
    creditAvailable: number;
    creditLimit: number;
    creditLimitUsed: number;
    currentBalanceAmount: number;
    currentBalanceCountItems: number;
    pastDueBalanceAmount: number;
    pastDueBalanceCountItems: number;
    pendingOrders: number;
    totalBalanceAmount: number;
    totalBalanceCountItems: number;
}

export interface AccountSummary {
    data: Data;
}
